import React, { useEffect } from 'react';
import { DownloadFileAPI } from '../../services';
import { DownloadByContent, mimeTypes } from '../utils';

const HTMLCode = ({ innerHtml, className}) =>
{
	useEffect(() =>
	{
		document.querySelectorAll('.HTML_code a').forEach(element =>
		{
			element.addEventListener('click', function(event)
			{
				if(element.href.indexOf('entryPoint=download&id=') === -1)
				{
					return;
				}
				event.preventDefault();
				const fileID = element.href.split('entryPoint=download&id=')[1];
				DownloadFileAPI(fileID).then(response =>
				{
					if(response && response.content)
					{
						DownloadByContent(response.content, response.name);
					}
				});
			});
		});
		document.querySelectorAll('.HTML_code img').forEach(element =>
		{
			const SRC = element.getAttribute('src');
			if(SRC.indexOf('entryPoint=download&id=') !== -1 && SRC.indexOf('&utype=') === -1)
			{
				const fileID = SRC.split('entryPoint=download&id=')[1];
				DownloadFileAPI(fileID).then(APIResponse =>
				{
					let extension = '';
					if(APIResponse.extension)
					{
						extension = APIResponse.extension;
					}
					else if(APIResponse.name && APIResponse.name.indexOf('.') > -1)
					{
						extension = APIResponse.name.split('.').slice(-1)[0];
					}
					const mime = mimeTypes[extension];
					let fileSRC = APIResponse.url;
					if(typeof mime !== 'undefined' && mime.includes('image') && APIResponse.content.length)
					{
						fileSRC = 'data:'+mime+';base64,'+APIResponse.content;
					}
					element.style.maxHeight = '100px';
					element.style.borderRadius = '8px';
					element.style.cursor = 'pointer';
					element.src = fileSRC;
					element.addEventListener('click', function()
					{
						DownloadFileAPI(fileID).then(response =>
						{
							if(response && response.content)
							{
								DownloadByContent(response.content, response.name);
							}
							else if(APIResponse.url)
							{
								const downloadLink = document.createElement("a");
								downloadLink.href = APIResponse.url;
								downloadLink.download = APIResponse.name;
								downloadLink.click();
							}
						});
					});
				});
			}
		});
	}, [innerHtml]);

	if(innerHtml.indexOf('><br><') !== -1)
	{
		innerHtml = innerHtml.replaceAll("<br>", "");
	}

	return <div className={className + " HTML_code"} dangerouslySetInnerHTML={{ __html: innerHtml }}/>
};

export default HTMLCode;
